export const CMS_PAGE_OPTIONS = [
  'Ways to Fly',
  'FAQ',
  'Safety & Security',
  'About Us',
  'Contact Us',
  'Investor Relations',
  'Career',
  'News',
  'Terms & Conditions',
  'Refund & Cancellation',
  'Privacy Policy',
  'Cookie Policy',
  'How It Works',
  'What We Do',
  'Who We Are'
];
